export default "__VITE_ASSET__bc9ab02f__"